import { render, staticRenderFns } from "./OpensTable.vue?vue&type=template&id=7a874a34&class=chart&"
import script from "./OpensTable.vue?vue&type=script&lang=js&"
export * from "./OpensTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports